module.exports = __webpack_public_path__ + "static/intro-bg-69cd5ed3c08fb38a9f9a6ff24fd891cc.png";